module.exports = __webpack_public_path__ + "static/img/coe-heavy-horse-green.c36027e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/coe-heavy-horse-green.svg
// module id = oN/I
// module chunks = 74